<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.DetailedEntryRulesConfiguration')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="440px"
  >

    <el-form v-model="form">
      <span v-show="isStep1">
        <el-form-item label-width="0" style="margin-bottom: 2px !important;">
          <div :style="{ display: 'inline-block', width: $selectByLang('100px', '120px', '120px', '120px', '120px', '120px'), marginRight: '20px', textAlign: 'right' }">
            <span>{{ $t('CargoMsg.Cargo_VoucherGroupingType') }}</span>
          </div>
          <el-select
            v-model="form.accountingDocumentRuleUuid"
            style="width: 200px;"
            @change="checkAvailableEntryTypes"
          >
            <el-option
              v-for="(item, index) in accountingDocumentsRules"
              :key="index"
              :value="item.uuid"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 2px !important;">
          <div :style="{ display: 'inline-block', width: $selectByLang('100px', '120px', '120px', '120px', '120px', '120px'), marginRight: '20px', textAlign: 'right' }">
            <span>{{ $t('CargoMsg.Cargo_GroupingTypesOfJournalEntries') }}</span>
          </div>
          <el-select v-model="form.entryRuleUuid" style="width: 200px;">
            <el-option
              v-for="(item, index) in entryRules"
              :key="index"
              :value="item.uuid"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
      </span>
      <span v-show="!isStep1">
        <div class="app-main-inner-row" style="justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_IndexName')" style="width: 260px">
            <el-input v-model="form.defaultSummary" style="width: 200px;" />
          </el-form-item>
          <el-form-item v-show="enableSummaryDimensionOrder" :label="$t('CargoMsg.Cargo_SequenceNumber')" style="width: 120px;padding-left: 5px;">
            <el-input-number
              v-model="form.sequenceNo"
              :min="0"
              :precision="0"
              style="width:60px;"
              :controls="false"
              @blur="e => { if (e.target.value < 0) form.sequenceNo = undefined }"
            />
          </el-form-item>
        </div>
        <div v-show="enableSummaryDimensionOrder" class="app-main-inner-row" style="justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_IndexName')" style="width: 260px">
            <el-input v-model="form.secondSummary" style="width: 200px;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SequenceNumber')" style="width: 120px;padding-left: 5px;">
            <el-input-number
              v-model="form.secondSequenceNo"
              :min="0"
              :precision="0"
              style="width:60px;"
              :controls="false"
              @blur="e => { if (e.target.value < 0) form.secondSequenceNo = undefined }"
            />
          </el-form-item>
        </div>
        <div class="app-main-inner-row row-grid">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </span>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="isStep1" type="primary" @click="nextStepHandler">{{ $t('common.btn.next') }}</el-button>
      <el-button v-else type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as accountingDocumentsRuleApi from '@/api/financeManage/accountingDocumentsRule'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import FinanceUtil from '@/utils/FinanceUtil'
import * as accountingEntryRuleApi from '@/api/financeManage/accountingEntryRule'
import { getGridSelected } from '@/utils/agGrid'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'

export default {
  name: 'SummaryRuleSelectorDialog',
  props: {
    visible: { type: Boolean, require: true },
    entrySummaryRule: { type: Object, default: null },
    accountSet: { type: Object, default: null },
    enableSummaryDimensionOrder: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      accountingDocumentsRules: [],
      entryRules: [],
      entryRuleUuid: '',
      isStep1: true,
      form: {
        accountingDocumentRuleUuid: '',
        entryRuleUuid: '',
        defaultSummary: '',
        secondSummary: '',
        secondSequenceNo: ''
      },
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        }
      },
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'sequenceNo',
          width: 90,
          editable: true,
          hide: !this.enableSummaryDimensionOrder,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              min: 1,
              max: 100,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions'),
          field: 'dimension',
          width: 120,
          cellRenderer: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Format'),
          field: 'displayFormat',
          width: 120,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }
      ]
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        if (this.entrySummaryRule && this.entrySummaryRule.entryType === 0) {
          this.form.accountingDocumentRuleUuid = ''
          this.form.entryRuleUuid = ''
          this.loadAccountingDocumentsRules()
          this.isStep1 = true
        } else {
          this.isStep1 = false
          const documentRule = this.accountingDocumentsRules.find(rule => rule.businessDataType === this.entrySummaryRule.businessDataType)
          const params = {}
          params.accountSetUuid = this.accountSet.uuid
          params.accountingDocumentRuleUuid = documentRule.uuid
          const entryRule = await accountingEntryRuleApi.query(params).then(resp => {
            return resp.data.list.find(rule => rule.entryType === this.entrySummaryRule.entryType)
          })
          this.fillGroupingDimension(documentRule, entryRule)
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    this.loadAccountingDocumentsRules()
  },
  methods: {
    async loadAccountingDocumentsRules() {
      const accountingDocumentsRules = this.accountSet.accountingDocumentsRule // await accountingDocumentsRuleApi.query({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data.list)
      for (const rule of accountingDocumentsRules) {
        rule.name = this.bizTypeDDLLabelFun(rule)
      }
      this.accountingDocumentsRules = accountingDocumentsRules
    },
    saveHandler() {
      if (this.validate()) {
        const newEntrySummaryDimension = []
        const selectedRows = getGridSelected(this.gridOptions)
        for (const item of selectedRows) {
          const dimension = {}
          dimension.dimension = item.dimension
          dimension.displayFormat = item.displayFormat
          dimension.sequenceNo = item.sequenceNo
          dimension.entrySummaryRuleUuid = this.entrySummaryRule.uuid
          newEntrySummaryDimension.push(dimension)
        }
        if (!this.entrySummaryRule.uuid) {
          this.entrySummaryRule.accountSetUuid = this.accountSet.uuid
        }
        this.entrySummaryRule.entrySummaryDimension = newEntrySummaryDimension
        this.entrySummaryRule.defaultSummary = this.form.defaultSummary
        this.entrySummaryRule.sequenceNo = this.form.sequenceNo ? this.form.sequenceNo : 0
        this.entrySummaryRule.secondSummary = this.form.secondSummary
        this.entrySummaryRule.secondSequenceNo = this.form.secondSequenceNo ? this.form.secondSequenceNo : 0
        this.$emit('saveHandler', this.entrySummaryRule)
      }
    },
    async checkAvailableEntryTypes() {
      const rule = this.accountingDocumentsRules.find(rule => rule.uuid === this.form.accountingDocumentRuleUuid)
      let key = rule ? rule.businessDataType.toString() : ''
      if (rule && rule.accountingMode === FinanceInterfaceConstants.MODE_HEDGE.code) {
        key += '#'
      }
      const entryRules = Array.from(FinanceInterfaceConstants.MAPPING[key])
      const availableEntries = []
      if (rule && !rule.accountingEntryRule) {
        const params = {}
        params.accountingDocumentRuleUuid = rule.uuid
        params.accountSetUuid = this.accountSet.uuid
        await accountingEntryRuleApi.query(params).then(resp => {
          rule.accountingEntryRule = resp.data.list
        })
      }
      const accountingEntryRules = rule ? rule.accountingEntryRule : []
      for (const entryRule of accountingEntryRules) {
        const state = CommonState.getStateByCode(entryRules, entryRule.entryType)
        // 如果不属于关联分录，那么就继续
        if (!state) continue
        let exist = false
        for (const summaryRule of this.accountSet.entrySummaryRule) {
          if (summaryRule.businessDataType === rule.businessDataType && summaryRule.entryType === entryRule.entryType) {
            exist = true
            break
          }
        }
        if (!exist) {
          entryRule.name = FinanceUtil.entryTypeLabelFunc(entryRule.entryType)
          availableEntries.push(entryRule)
        }
      }
      this.entryRules = availableEntries
      this.form.entryRuleUuid = ''
    },
    bizTypeDDLLabelFun(rule) {
      const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, rule.businessDataType)
      let label = state == null ? '' : state.chineseName
      if (label && rule.accountingMode && rule.accountingMode === FinanceInterfaceConstants.MODE_HEDGE.code) {
        label += '(' + FinanceInterfaceConstants.MODE_HEDGE.chineseName + ')'
      }
      return label
    },
    nextStepHandler() {
      if (!this.form.entryRuleUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectTypeOfJournalEntries'))
        return
      }
      this.isStep1 = false
      const documentRule = this.accountingDocumentsRules.find(rule => rule.uuid === this.form.accountingDocumentRuleUuid)
      const entryRule = this.entryRules.find(rule => rule.uuid === this.form.entryRuleUuid)
      this.fillGroupingDimension(documentRule, entryRule)
    },
    // 根据选择的分组维度和分录维度，填充
    fillGroupingDimension(documentRule, entryRule) {
      this.form.defaultSummary = this.entrySummaryRule.defaultSummary
      this.form.sequenceNo = this.entrySummaryRule.sequenceNo
      this.form.secondSummary = this.entrySummaryRule.secondSummary
      this.form.secondSequenceNo = this.entrySummaryRule.secondSequenceNo
      let count = documentRule == null ? 0 : this.getGroupingDimensionCount(documentRule)
      const map = new Map()
      let dim
      let summaryDimension
      for (let i = 1; i <= count; i++) {
        const key = 'groupingDimension' + i
        if (!Object.keys(documentRule).includes(key)) continue
        dim = documentRule[key]
        if (!map.has(dim)) {
          summaryDimension = this.containsDimension(dim)
          map.set(dim, {
            selected: summaryDimension != null,
            dimension: dim,
            displayFormat: summaryDimension == null ? '' : summaryDimension.displayFormat,
            sequenceNo: summaryDimension == null ? 1 : summaryDimension.sequenceNo
          })
        }
      }
      count = entryRule == null ? 0 : this.getGroupingDimensionCount(entryRule)
      for (let i = 1; i <= count; i++) {
        const key = 'groupingDimension' + i
        if (!Object.keys(entryRule).includes(key)) continue
        dim = entryRule[key]
        if (!map.has(dim)) {
          summaryDimension = this.containsDimension(dim)
          map.set(dim, {
            selected: summaryDimension != null,
            dimension: dim,
            displayFormat: summaryDimension == null ? '' : summaryDimension.displayFormat,
            sequenceNo: summaryDimension == null ? 1 : summaryDimension.sequenceNo
          })
        }
      }
      count = entryRule == null ? 0 : this.getAuxiliaryGroupingCount(entryRule)
      for (let i = 1; i <= count; i++) {
        const key = 'auxiliaryGrouping' + i
        if (!Object.keys(entryRule).includes(key)) continue
        dim = entryRule[key]
        if (!map.has(dim)) {
          summaryDimension = this.containsDimension(dim)
          map.set(dim, {
            selected: summaryDimension != null,
            dimension: dim,
            displayFormat: summaryDimension == null ? '' : summaryDimension.displayFormat,
            sequenceNo: summaryDimension == null ? '' : summaryDimension.sequenceNo
          })
        }
      }
      this.entrySummaryRule.businessDataType = documentRule == null ? 0 : documentRule.businessDataType
      this.entrySummaryRule.entryType = entryRule == null ? 0 : entryRule.entryType
      const rowData = []
      map.forEach(value => rowData.push(value))
      this.rowData = rowData
      this.$nextTick(() => {
        // 选中标记项
        const nodes = this.gridOptions.api.getRenderedNodes()
        for (const node of nodes) {
          if (node && node.data && node.data.selected) {
            node.setSelected(true)
          }
        }
      })
    },
    getProperityCount(entryRule, prop) {
      if (!entryRule) return 0
      let count = 0
      for (let i = 1; i <= 6; i++) {
        const dim = entryRule[prop + i]
        if (Number(dim) > 0) {
          count++
        } else {
          break
        }
      }
      return count
    },
    // 分组条件数量
    getGroupingDimensionCount(entryRule) {
      return this.getProperityCount(entryRule, 'groupingDimension')
    },
    // 辅助核算条件数量
    getAuxiliaryGroupingCount(entryRule) {
      return this.getProperityCount(entryRule, 'auxiliaryGrouping')
    },
    containsDimension(dimension) {
      if (!this.entrySummaryRule || !this.entrySummaryRule.entrySummaryDimension) return null
      for (const summaryDimension of this.entrySummaryRule.entrySummaryDimension) {
        if (summaryDimension.dimension === dimension) {
          return summaryDimension
        }
      }
      return null
    },
    validate() {
      const selectedRows = getGridSelected(this.gridOptions)
      const hasSelected = selectedRows.length > 0
      // for (const item of this.rowData) {
      //   if (item.selected) {
      //     hasSelected = true
      //     break
      //   }
      // }
      if (!hasSelected && this.form.defaultSummary.trim().length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SALOGROEI'))
        return false
      }
      return true
    },
    resetForm() {
      const form = {
        accountingDocumentRuleUuid: '',
        entryRuleUuid: '',
        defaultSummary: ''
      }
      Object.assign(this.form, form)
    }
  }
}
</script>

<style scoped>

</style>
